module.exports = __webpack_public_path__ + "static/media/MentalHealth.bd60ab4f.svg";